import "./Crud.css";
import React, { useEffect } from "react";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteOutline, MdUnarchive } from "react-icons/md";
import { IoMdArchive } from "react-icons/io";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { useState } from "react";
import { useForm } from "react-hook-form";
import Button from "react-bootstrap/Button";
import {
  updateOnFalse,
  updateOnTrue,
  deleteElement,
  onDeleteUser,
} from "../../Firebase";
import Form from "react-bootstrap/Form";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link } from "react-router-dom";
import {
  MODIFIER_COURS_ADMIN_NAVIGATION,
  MODIFIER_COURS_NAVIGATION,
} from "../../Routes/NAVIGATION_PATH";


function Crud({ isArchived, isApproved, elt_collection, id }) {
  const [Archive, setArchive] = useState("");
  const [desArchive, setDesArchive] = useState("");

  const myArchice = "isArchived";
  const trueArchive = "Approuver avec succès";
  const falseArchive = "Désapprouver avec succès";

  // const {
  //   register,
  //   handleSubmit,
  //   onSubmit,
  //   reset,
  //   formState: { errors },
  // } = useForm();

  return (
    <Dropdown className="dropdow132" as={ButtonGroup}>
      <Dropdown.Toggle id="dropdown-custom-1">
        <BiDotsVerticalRounded className="icon132 " />
      </Dropdown.Toggle>
      <Dropdown.Menu className="super-colors dropdow133">
        <h6 className="text-center">Actions</h6>
        <Dropdown.Item eventKey="1">
          {/* <button  onClick={handleShow} >Edit</button>  */}
          <Link to={`${MODIFIER_COURS_ADMIN_NAVIGATION}${id}`}>
            <Button variant="primary" className="text-dark">
              <FaRegEdit /> Modifier
            </Button>
          </Link>
        </Dropdown.Item>
        <Dropdown.Item eventKey="2">
          {isApproved === true ? (
            <button
              onClick={() => {
                updateOnTrue(elt_collection, id, "isApproved", trueArchive);
              }}
            >
              <IoMdArchive /> Approuver
            </button>
          ) : (
            <button
              onClick={() => {
                updateOnFalse(elt_collection, id, "isApproved", falseArchive);
              }}
            >
              <MdUnarchive /> Désapprouver
            </button>
          )}
        </Dropdown.Item>
        {isArchived === true ? null : (
          <Dropdown.Item eventKey="3">
            <button
              onClick={() => {
                updateOnTrue(
                  "cours",
                  id,
                  "isArchived",
                  "Rejetter avec succès !"
                );
              }}
            >
              <MdDeleteOutline /> Rejetter
            </button>
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default Crud;
